import { create } from 'zustand';

interface ToolboxState {
  enabledAddonIds: string[];
  addAddonCategory: (id: string) => void;
  removeAddonCategory: (id: string) => void;
  clearAddonCategories: () => void;
  isAddonEnabled: (id: string) => boolean;
}

export const useToolboxStore = create<ToolboxState>((set, get) => ({
  enabledAddonIds: [],
  addAddonCategory: (id) =>
    set((state) => {
      if (state.enabledAddonIds.includes(id)) {
        return state;
      }
      return { enabledAddonIds: [...state.enabledAddonIds, id] };
    }),
  removeAddonCategory: (id) =>
    set((state) => ({
      enabledAddonIds: state.enabledAddonIds.filter((entry) => entry !== id),
    })),
  clearAddonCategories: () => set({ enabledAddonIds: [] }),
  isAddonEnabled: (id) => get().enabledAddonIds.includes(id),
}));
